// Mounted once at the app root (Routes.js), inside <BrowserRouter>. Renders
// nothing; starts the presence signal described in utils/presenceBeacon.js
// and removes all its listeners/timers on unmount. Each route change is
// reported as one page view (path only, never the query string).
import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { startPresence, presenceDisabled } from "../../utils/presenceBeacon";

const PresenceBeacon = () => {
  const presence = useRef(null);
  const location = useLocation();
  useEffect(() => {
    if (presenceDisabled()) return undefined;
    const stop = startPresence();
    presence.current = stop;
    return () => {
      presence.current = null;
      stop();
    };
  }, []);
  useEffect(() => {
    presence.current?.pageView?.(location.pathname, location.key);
  }, [location.pathname, location.key]);
  return null;
};

export default PresenceBeacon;
